const defaultState = {
  vin: {},
  error: null,
  fetching: false,
  fetched: false
};

const isVinValidReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'ISVINVALID_FETCH_PENDING': {
      return {
        ...state, fetching: true
      };
    }
    case 'ISVINVALID_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, vin: action.payload.data
      };
    }
    case 'ISVINVALID_FETCH_REJECTED': {
      return {
        ...state, fetching: true, fetched: false, error: action.playload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default isVinValidReducer;


// WEBPACK FOOTER //
// ./src/reducers/isVinValid.js